export const _2SHOP = ''
export const _9_JOURS = ''
export const A_ACCENT = 'à'
export const A_JOINDRE_DANS_COLIS = 'A joindre dans votre colis'
export const A_PARTIR_DE_MAJ = 'À PARTIR DE'
export const A_PROPOS_DE_MODZ = 'À propos de Modz'
export const A_VENIR_TRES_PROCHAINEMENT = 'À venir très prochainement !'
export const ACCEDER_A_MES_CMD = 'Accéder à mes commandes'
export const ACCEDER_A_MES_INFOS = 'Accéder à mes infos'
export const ACCEDER_A_MES_RETOURS = 'Accéder à mes retours'
export const ACCEDER_AU_FORMULAIRE_DE_CONTACT = 'Accéder au formulaire de contact'
export const ACCEDEZ_A_VOS_DONNES_PERSOS = 'Accédez à vos données personnelles'
export const ACCEPTER_CGV = 'En cliquant sur COMMANDER, vous acceptez les'
export const ACCES_ALL_PDTS_MARQUE_MAJ = 'ACCÉDER À TOUS LES PRODUITS DE LA MARQUE'
export const ACCUEIL = 'Accueil'
export const ACHAT_EXPRESS = 'Achat Express'
export const ACHETER = 'Acheter'
export const ACTIVE = 'Activé'
export const ADRESSE = 'Adresse'
export const ADRESSE_FACTURATION = 'Adresse de facturation'
export const ADRESSE_LIVRAISON = 'Adresse de livraison'
export const ADRESSE_LIVRAISON_MODIFIER = 'Votre adresse de livraison a été modifié pour cette commande.'
export const ADRESSE_MAIL = 'Adresse e-mail'
export const AFFICHER = 'Afficher'
export const AFFICHER_PLUS_PRODUITS = 'Afficher plus de produits'
export const AGE = 'Age'
export const AGES = 'Ages'
export const AIDE = 'Aide'
export const AJOINDRE_DANS_VOTRE_COLIS_MAJ = '(A JOINDRE DANS VOTRE COLIS SVP)'
export const AJOUTER = 'Ajouter'
export const AJOUTER_A_MON_PANIER = 'AJOUTER À MON PANIER'
export const AJOUTER_AUX_FAVORIS = 'Ajouter aux favoris'
export const AJOUTER_PANIER = 'AJOUTER AU PANIER'
export const AJOUTER_PROFIL = 'Ajouter un profil'
export const AJOUTER_UNE_MARQUE = 'Ajouter une marque'
export const AJUSTEMENT_TVA = 'Ajustement lié à la TVA'
export const ALERTE_ACTIVE_POUR = 'L\u0027alerte sera activée pour'
export const ALERTES_AVANT_PREMIERE = 'avant première'
export const ALERTES_CEST_POURQUOI = 'C\u0027est pourquoi nous vous proposons d\u0027être informé en'
export const ALERTES_DE_NOS_ARRIVAGES = 'de nos arrivages. En quelques clics seulement, créez vos alertes et recevez les nouveautés en fonctions de vos critères. Ne perdez pas une minute pour profiter des bons plans avant les autres !'
export const ALERTES_MES_ALERTES = 'Mes alertes'
export const ALERTES_MODZ_NUM1_DESTOCKAGE = 'Modz, numéro 1 du déstockage des boutiques de mode, vous propose des'
export const ALERTES_NE_MANQUEZ_PLUS_LE_PRODUIT = 'Ne manquez plus le produit dont vous rêviez !'
export const ALERTES_NLLES_PIECES = 'nouvelles pièces'
export const ALERTES_NOM_ALERTE = 'Nom de l\u0027alerte'
export const ALERTES_TLJ_CES_PIECES = 'tous les jours. Ces pièces sont pour la plupart'
export const ALERTES_UNIQUES_COURTISEES = 'uniques et très courtisées'
export const ANNULE = 'ANNULÉ'
export const APPEL_FACTURE = 'Appel facturé'
export const APPLIQUER_CODE_MAJ = 'APPLIQUER LE CODE'
export const ARTICLE = 'article'
export const ARTICLE_AJOUT_FAVORIS_MSG = 'L\u0027article a bien été ajouté à votre liste de favoris.'
export const ARTICLE_BIEN_AJOUTE_PANIER = 'L\u0027article a été ajouté dans le panier.'
export const ARTICLE_DANS_FAVORIS = 'article dans vos favoris'
export const ARTICLE_EST_DANS_VOTRE_PANIER = 'L’article est dans votre panier'
export const ARTICLE_EXPE_24H = 'Article expédié en 24h'
export const ARTICLES = 'articles'
export const ARTICLES_DANS_FAVORIS = 'articles dans vos favoris'
export const ATTENTION = 'Attention'
export const AU = 'au'
export const AUCUN_ESCOMPTE_ACCORDE = 'Aucun escompte pour paiement anticipé n\u0027est accordé.'
export const AUCUN_PRODUIT_CORRESPONDANT_SANS_MARQUES = 'Nous n’avons plus aucun produit correspondant à votre recherche.\r\n\u003cbr /\u003eDemain, il y aura \u003cspan class=\"PoppinsSemiBold\"\u003e3 000 nouveautés\u003c/span\u003e en plus sur le site donc restez connecté !'
export const AUCUNRETOURENREGISTRE = 'Aucun retour enregistré'
export const AULIEUDE = 'au lieu de'
export const AUTOUR_DE_MOI = 'Autour de moi'
export const AUTRE = 'Autre'
export const AUTRES_PAYS = 'Autres pays'
export const AUTRES_VILLES = 'Autres villes'
export const AVANTAGE_CODE_PROMO = 'Avantage code promotionnel'
export const AVANTAGE_CODE_PROMO_DOTS = 'Avantage code promotionnel ...................'
export const AVANTAGE_REDUCTION = 'Avantages, promos, réduction -'
export const AVEC = 'avec'
export const AVEC_MONDIAL_RELAY = 'avec Mondial Relay.'
export const AVEC_MONDIAL_RELAY_MAJ = 'AVEC MONDIAL RELAY'
export const AVEC_PROPER = 'Avec'
export const AVIS_CLIENTS = 'AVIS CLIENTS'
export const AVIS_TRUSTPILOT = 'Voir les avis de http://trustpilot.fr'
export const AVOIR = 'Avoir'
export const AVOIR_ETE_PORTE = '- Avoir été porté'
export const BAS = 'Bas'
export const BAS_MAJ = 'BAS'
export const BENEFICIER_MAJ = 'BENEFICIER'
export const BESOINAIDE = 'Besoin d\u0027aide? Commander par téléphone ?'
export const BOHEME_FP = 'bohèmes'
export const BON_ACHAT = 'Bon d\u0027achat'
export const BON_RETOUR_ARTICLES_ABSENTS = 'Votre retour ne comprenait pas le(s) produit(s) suivant(s) :'
export const BON_RETOUR_ARTICLES_REFUSES = 'Nous avons refusés le(s) produit(s) suivant(s) :'
export const BONDERETOUR = 'Bon de retour'
export const BONJOUR = 'Bonjour'
export const BONNE_ANNEE = 'Bonne année'
export const BONNE_IDEE = 'Bonne idée \u003e'
export const BONNE_NOUVELLE_LIVRAISON_GRATUITE = 'Bonne nouvelle ! Vous bénéficiez de la livraison gratuite.'
export const BONS_PARRAINAGE = 'Bons de parrainage'
export const BONUS = 'Bonus'
export const BORDEREAU_RETOUR = 'Bordereau de retour'
export const BORDEREAU_RETOUR_MAJ = 'BORDEREAU DE RETOUR'
export const BR_A_RECEPTION_MODZ = 'A réception, Modz créditera votre compte d\u0027un avoir utilisable immédiatement, vous bénéficierez de la possibilité de demander le remboursement.'
export const BR_LES_CGV_APPLICABLE_A_VOTRE_CMD = 'Les conditions Générales de vente applicables à votre commande acceptées lors de votre enregistrement sont disponibles sur notre site. Les consommateurs disposent d\u0027un délai de 14 Jours francs à compter de la réception des biens pour exercer leur droit de rétractation sans avoir à justifier de motif ni à payer de pénalités, à l\u0027exception des frais de retour.'
export const BRAVO_VOUS_VENEZ_DE_METTRE_LA_MAIN = 'Bravo ! Vous venez de mettre la main sur le dernier produit disponible !'
export const BUREAU = 'Bureau'
export const CARACTERISTIQUE_PRINCIPALE = 'Détails et Formes'
export const CARTES_BANCAIRES = 'Cartes bancaires'
export const CATEGORIE = 'Catégorie'
export const CATEGORIES = 'Catégories'
export const CELA_POURRAIT_VOUS_INTERESSER = 'Cela pourrait vous intéresser'
export const CEST_PARTI = 'C\u0027est parti !'
export const CET_ART_A_BIEN_ETE_AJOUTE = '\u003cspan class=\"d-block\"\u003eCet article a bien été ajouté\u003c/span\u003e\r\n\u003cspan class=\"d-block\"\u003eà votre panier\u003c/span\u003e'
export const CET_ARTICLE_A_ETE_VENDU = 'Cet article a été vendu.'
export const CET_ARTICLE_NEST_PLUS_DISPO = 'Cet article n\u0027est plus disponible.'
export const CETTE_PAGE_SECURISEE = 'Cette page sécurisée est la page d\u0027accueil de votre compte Modz. Elle regroupe tous les outils utiles pour gérer vos commandes, modifier vos informations personnelles ou créer des alertes. Vous y trouverez aussi notre offre de parrainage afin de bénéficier de 20€ sur votre prochaine commande.'
export const CGV_MODZ = 'conditions générales de vente de Modz.'
export const CHAMPS_OBLIGATOIRES = '* Champs obligatoires'
export const CHANGER_MON_MDP = 'Changer mon mot de passe'
export const CHAQUE_JOUR_NOUVEAUTES_EN_LIGNE = 'Chaque jour, ce sont plus de 1.500 nouveautés en ligne. Découvrez-les vite !'
export const CHARGEMENTZOOM = 'Chargement du zoom...'
export const CHAUSSURE = 'Chaussure'
export const CHAUSSURES = 'Chaussures'
export const CHAUSSURES_MAJ = 'CHAUSSURES'
export const CHEQUE = 'Chèque'
export const CHEQUE_1 = 'Chèque numéro 1:'
export const CHEQUE_2 = 'Chèque numéro 2:'
export const CHEQUE_3 = 'Chèque numéro 3:'
export const CHERCHER_AUTOUR_DE_MOI = 'Chercher autour de moi'
export const CHIFFRE24H = '24h'
export const CHOISIR_AUTRE_ADRESSE = 'Choisir une autre adresse'
export const CHOISIR_UN_FICHIER = 'Choisir un fichier'
export const CHOISISSEZ_MODE_EXPE_COLIS = 'Choisissez le mode d\u0027expédition de votre colis.'
export const CHOISISSEZ_TRANSPORTEUR_DE_VITRE_CHOIX = 'Choisissez le transporteur de votre choix.'
export const CHOIX = 'Choix'
export const CHOIX_PAIEMENT_3XCHEQUE = 'Vous avez choisi de régler par chèques 3 fois sans frais,\r\nnous vous informons que vous devez établir 3 chèques, à l\u0027ordre de Modz.fr,\r\ndes montants suivants :'
export const CHOIX_PAIEMENT_CHEQUE = 'Vous avez choisi de régler par chèque, nous vous informons que vous devez établir votre chèque à l\u0027ordre de Modz.fr et l\u0027envoyer à l\u0027adresse suivante :'
export const CHOIX_PAIEMENT_VIREMENT = 'Vous avez choisi de régler par virement bancaire pour un montant total de '
export const CHOIX_PAIEMENT_VIREMENT2 = 'nos coordonnées bancaires sont les suivantes :'
export const CHOIX_POINT_RELAY = 'Choix du point relais'
export const CINQ_EUROS = '5€'
export const CIVILITE = 'Civilité'
export const CLIQUANT_ICI = 'cliquant ici'
export const CLIQUER_ICI = 'cliquez ici'
export const CLIQUEZ_ICI = 'Cliquez ici'
export const CLIQUEZ_POUR_AGRANDIR = 'Cliquez sur l\u0027image pour agrandir'
export const CLIQUEZPOURZOOM = 'Cliquez sur l\u0027image pour agrandir'
export const CLUB_AUCUN_ARTICLE_ELIGBLE = 'Vous n\u0027avez pas d\u0027article éligible actuellement.'
export const CLUB_BENEFICIER_AVOIR_OU_REMBOURSEMENT = '5. Bénéficier d’un avoir ou d’un remboursement'
export const CLUB_CARTE_CADEAU_LORS_DU_PAIEMENT = 'Lors du paiement de votre commande, le solde de vos bons d’achat apparaitra et il vous suffira de cocher la case pour que le montant soit déduit de votre commande.'
export const CLUB_CARTE_CADEAU_SUCCES = 'Bravo ! Votre carte a bien été enregistrée. Bon shopping !'
export const CLUB_CARTECADEAU = 'Carte cadeau'
export const CLUB_COCHEZ_LES_ARTICLES = 'Cochez les articles que vous souhaitez retourner et indiquez le motif. Choisissez ensuite votre mode d’expédition.'
export const CLUB_COLLER_ETIQUETTE_MR_COLIS = 'Coller l’étiquette sur votre colis.'
export const CLUB_CONTACT = 'Contact'
export const CLUB_CONTACTEZNOUS = 'Contactez-nous'
export const CLUB_DEMANDE_DE_RETOUR = 'Demande de retour'
export const CLUB_DEPOSER_COLIS_DANS_POINT_RELAIS = 'Déposez votre colis dans le point relais suivant :'
export const CLUB_DEPOSEZ_COLIS_AVEC_SHOPPING_TRANQUILLE = 'Déposez le colis dans le point relais que vous avez choisi.'
export const CLUB_DEPOSEZ_COLIS_INTERNATIONNAL = 'Déposez le colis dans un bureau de poste.'
export const CLUB_DESCR_PREPARATION_RETOUR = 'Les articles doivent être pliés dans leur emballage d’origine avec toutes les étiquettes,\r\nou boite originale pour les chaussures, le tout dans un colis correctement fermé.\r\nConstituez solidement votre colis car la marchandise voyage à vos frais et périls.'
export const CLUB_EN_FONCTION_DU_MODE_DE_LIVRAISON_SANS_SHOPPING_TRANQUILLE = 'En fonction du mode de livraison choisi, déposez le colis dans un bureau de poste ou un point relais.'
export const CLUB_ETIQUETTE_MR_A_COLLER = 'L\u0027étiquette (à coller sur votre colis) \u003e'
export const CLUB_EXPEDIER_COLIS = '4. Expédier votre colis'
export const CLUB_IMRIMER_ETIQUETTE_MR = '3. Imprimer l\u0027étiquette'
export const CLUB_INDIQUER_ADRESSE_RETOUR_COLIS = '3. Indiquer l’adresse de retour sur votre colis'
export const CLUB_INDIQUEZ_ADRESSE_RETOUR_COLIS = 'Indiquez l’adresse de retour sur votre colis :'
export const CLUB_LAVES_REPASSES = '- Lavés et/ou repassés'
export const CLUB_LES_ARTICLES_NE_DOIVENT_PAS_AVOIR_ETE = 'Les articles ne doivent pas avoir été :'
export const CLUB_MARQUES_PREFEREES = 'Mes marques préférées'
export const CLUB_MES_ARTICLES_ELIGIBLES_RETOUR = 'Mes articles éligibles au retour'
export const CLUB_MES_COULEURS_FAVORITES = 'Mes couleurs favorites'
export const CLUB_MES_DEMANDES_DE_RETOUR = 'Mes demandes de retour'
export const CLUB_MES_PROFILS = 'Mes profils'
export const CLUB_MESABONNEMENTS = 'Mes abonnements'
export const CLUB_MESALERTES = 'Mes alertes'
export const CLUB_MESALERTESNOUVEAUTES = 'Mes alertes nouveautés'
export const CLUB_MESCOMMANDES = 'Mes commandes'
export const CLUB_MESINFOS = 'Mes infos'
export const CLUB_MESINFOSPERSO = 'Mes infos personnelles'
export const CLUB_MESRETOURS = 'Mes retours'
export const CLUB_MODIFIER_MES_MARQUES = 'Modifier mes marques préférés'
export const CLUB_MODIFIER_MES_MARQUES_PREFEREES = 'Modifier mes marques préférées'
export const CLUB_MODIFIER_MES_PRODUITS = 'Modifier mes produits fétiches'
export const CLUB_MODIFIER_MES_PRODUITS_FETICHES = 'Modifier mes produits fétiches'
export const CLUB_MODIFIER_MES_TAILLES = 'Modifier mes tailles'
export const CLUB_MODIFIER_MON_STYLE = 'Modifier mon style'
export const CLUB_MON_SOLDE_DE_COMPE = 'Mon solde de compte'
export const CLUB_MON_STYLE = 'Mon style'
export const CLUB_MONPROFIL = 'Mon profil'
export const CLUB_NEWS_SOUHAIT_1 = 'Être informé de toutes les actus et promos de Modz\r\n\u003cspan\u003e(pour que rien ne m\u0027échappe !)\u003c/span\u003e'
export const CLUB_NEWS_SOUHAIT_2 = 'Recevoir un récap sur les produits que j\u0027ai mis au panier\r\n\u003cspan\u003e(pour ne pas les oublier !)\u003c/span\u003e'
export const CLUB_NEWS_SOUHAIT_3 = 'Garder un oeil sur tous mes produits favoris\r\n\u003cspan\u003e(pour que personne d\u0027autre ne mette la main dessus !)\u003c/span\u003e'
export const CLUB_NEWS_SOUHAIT_4 = 'Être alerté dès qu\u0027un produit que j\u0027ai repéré revient en stock\u003cspan\u003e\r\n(pour qu\u0027il ne m\u0027échappe pas une 2e fois !)\u003c/span\u003e'
export const CLUB_NEWS_SOUHAIT_5 = 'Recevoir des offres exclusives en tant que client Modz\r\n\u003cspan\u003e(parce que je le vaux bien !)\u003c/span\u003e'
export const CLUB_NEWS_SOUHAIT_6 = 'Recevoir des alertes nouveautés de mes marques préférées\r\n\u003cspan\u003e\u003ca href=\"/club/alertes/\" class=\"text-color--pink underline\"\u003e(gérer mes alertes)\u003c/a\u003e\u003c/span\u003e'
export const CLUB_NEWS_SOUHAIT_7 = 'Être informé de toutes les actus et promos Seconde Main'
export const CLUB_PARRAINAGE = 'Parrainage'
export const CLUB_PARRAINAGE_BONACHAT_20E_CREDIT = 'Un bon d\u0027achat de 20€ sera crédité sur votre compte pour chaque\r\n1ère commande passée par vos filleuls !'
export const CLUB_PARRAINAGE_CREDITES_SUR_VOTRE_COMPTE = 'Crédités sur votre compte pour chaque 1ère commande passée\r\npar vos filleuls donc 5 filleuls = 100€ pour vous !'
export const CLUB_PARRAINAGE_FAITES_DECOUVRIR_MODZ = 'Et si vous faisiez découvrir Modz à vos amis afin de leur faire bénéficier de nos plus belles affaires… c’est gagnant gagnant !'
export const CLUB_PARRAINAGE_INVIATION_ENVOYEE = 'Votre invitation a bien été envoyée !'
export const CLUB_PARRAINAGE_PARRAINER = 'Parrainer !'
export const CLUB_PARRAINAGE_PARRAINER_PLUS_DAMIS = 'Parrainez encore plus d’amis '
export const CLUB_PARRAINAGE_PARRAINNEZ_VOS_AMIS = 'Parrainez vos amis en leur envoyant une invitation :'
export const CLUB_PARRAINAGE_POUR_VOS_FILLEULS = 'Pour vos filleuls'
export const CLUB_PARRAINAGE_PROFITEZ_DU_PROGRAMME_PARRAINAGE = 'Pour profiter du programme de parrainage et envoyez des invitations à vos amis, connectez-vous à votre compte client :'
export const CLUB_PARRAINAGE_SUR_1ERE_COMMANDE = 'Sur leur 1ère commande d’une valeur minimum de 50€.'
export const CLUB_PARRAINGE_15E_EN_BON_DACHAT = '15€ en bon d\u0027achat'
export const CLUB_PARRAINGE_20E = '20€'
export const CLUB_PARRAINGE_EN_BON_DACHAT = 'en bon\u003cbr /\u003ed\u0027achat'
export const CLUB_PARRAINGE_POUR_VOUS = 'Pour vous'
export const CLUB_PLACEZ_ARTICLE_AVEC_SHOPPING_TRANQUILLE = 'Placez le ou les articles dans le colis. Collez le code-barres sur le colis (par-dessus l’étiquette de livraison).'
export const CLUB_PLACEZ_ARTICLE_INTERNATIONNAL = 'Placez le ou les articles dans le colis.'
export const CLUB_PLACEZ_ARTICLE_SANS_SHOPPING_TRANQUILLE = 'Placez le ou les articles dans le colis. Pour un retour imprimez votre étiquette retour et collez le code-barres sur le colis (par-dessus l’étiquette de livraison).'
export const CLUB_PORTES = '- Portés'
export const CLUB_PREPARER_COLIS_RETOUR = '2. Préparer votre colis de retour'
export const CLUB_PRODUITS_FETICHE = 'Mes Produits fétiches'
export const CLUB_PROFIL_FEMME = 'Profil femme'
export const CLUB_PROFIL_FILLE = 'Profil Fille'
export const CLUB_PROFIL_GARCON = 'Profil Garçon'
export const CLUB_PROFIL_HOMME = 'Profil homme'
export const CLUB_REFPRODUIT = 'Réf. Produit'
export const CLUB_RENDEZ_VOUS_SUR_MODZ = 'Rendez-vous sur modz.fr. Connectez-vous à votre compte pour accéder à la rubrique Mes retours.'
export const CLUB_RENSEIGNER_CODE_CARTE = 'Il vous suffit de renseigner ci-dessous le\r\n\u003cb\u003ecode inscrit au dos de la carte\u003c/b\u003e\r\net vous serez immédiatement crédité du montant correspondant :'
export const CLUB_RESUME = 'Résumé'
export const CLUB_RETOUR_ACCUEIL_MON_COMPTE = 'Retourner à l\u0027accueil de mon compte'
export const CLUB_RETOUR_AVEC_SHOPPING_TRANQUILLE = 'En France / Belgique avec l’option Shopping Tranquille.'
export const CLUB_RETOUR_INTERNATIONNAL = 'A l’international.'
export const CLUB_RETOUR_SANS_SHOPPING_TRANQUILLE = 'En France / Belgique sans l’option Shopping Tranquille.'
export const CLUB_RETOURNER_ARTICLE = 'Comment retourner un article ?'
export const CLUB_SALIS = '- Salis'
export const CLUB_SHOPPING_TRANQUILLE_FRAIS_DE_RETOUR = 'Grâce au Shopping Tranquille, les frais de retour sont pris en charge par Modz.'
export const CLUB_SOLDE_COMPTE = 'Solde du compte'
export const CLUB_SUIVI_DES_RETOURS = 'Suivi des retours'
export const CLUB_TELECHARGEZ_ET_IMPRIMEZ = 'Téléchargez et imprimez'
export const CLUB_UTILISES_DAUCUNE_MANIER = '- Utilisés d\u0027aucune manière'
export const CLUB_VERIFIER_ETAT_ARTICLES = '1. Vérifier l\u0027état des articles'
export const CLUB_VOTRE_COMPTE_MODZ_EST_CREDITE = 'Votre compte Modz est crédité d\u0027un avoir dès réception du colis. Vous recevrez un email de confirmation lorsque votre avoir sera disponible sur votre compte.'
export const CLUB_VOTRE_DEMANDE_DE_RETOUR = 'Votre demande de retour'
export const CLUB_VOTRE_RETOUR_EST_ENGISTRE = 'Votre retour est enregistré !'
export const CLUB_VOUS_AVEZ_RECU_CARTE_CADEAU = 'Vous avez reçu une carte cadeau Modz et vous souhaitez vous faire plaisir ?'
export const CLUB_VOUS_RECEVREZ_UN_EMAIL_VOUS_CONFIRMANT_LA_RECEPTION = 'Vous recevrez un email vous confirmant la réception de votre colis et votre compte Modz sera instantanément crédité d’un avoir.'
export const COCHEZ_ARTCILES_SOUHAITEZ_RETOUR = 'Cochez le ou les articles que vous souhaitez renvoyer dans la rubrique \"Mes articles éligibles au retour\".'
export const CODE = 'Code'
export const CODE_POSTAL = 'Code Postal'
export const CODE_PROMO = 'Code promo'
export const CODEPOSTAL_ARNAS = '69400 Arnas'
export const COLORI = 'Coloris :'
export const COLORIS = 'Coloris'
export const COMMANDE = 'Commande'
export const COMMANDE_ATTENTE_MAJ = 'COMMANDE EN ATTENTE'
export const COMMANDE_ATTENTE_PAIEMENT = 'Vous avez une commande en attente de paiement'
export const COMMANDE_NUM = 'Commande n°'
export const COMMANDER_MAJ = 'COMMANDER'
export const COMPLEMENT_D_ADRESSE = 'Complément d\u0027adresse'
export const COMPLEMENTADRESSE = 'Complément d\u0027adresse'
export const COMPLETER_CE_PROFIL = 'Compléter ce profil'
export const COMPOSITION = 'Composition'
export const COMPTE = 'Compte'
export const CONFIRMATION_MAJ = 'CONFIRMATION'
export const CONFIRMATION_MOT_PASSE = 'Confirmation de mot de passe'
export const CONFIRMEZ_NOUVEAU_PASS = 'Confirmez votre nouveau mot de passe'
export const CONNECTEZ_VOUS_AVEC_VOTRE_COMPTE = 'Connectez-vous avec votre compte'
export const CONNECTEZ_VOUS_POUR_ECRIRE_MAIL = 'Pour nous écrire par mail, \u003cspan style=\"text-decoration:underline;\" class=\"pink\"\u003econnectez-vous ici\u003c/span\u003e.'
export const CONNECTEZ_VOUS_POUR_SUIVRE_MESSAGES = 'Connectez-vous pour voir le suivi de vos messages.'
export const CONNEXION = 'Connexion'
export const CONSEIL_DE_STYLE = 'Conseil de style'
export const CONSTITUER_SOLIDEMENT_VOTRE_COLIS = 'Constituer solidement votre colis car la marchandise voyage à vos frais et périls.'
export const CONSULTEZ_HISTO_CMD = 'Consultez l\u0027historique de vos commandes'
export const CONSULTEZ_SOLDE = 'Consultez votre solde d\u0027avoir disponible'
export const CONTACT = 'Contact'
export const CONTACT_ADRESSE_POSTAL_MODZ = 'Adresse Postale de MODZ pour toutes correspondances :\u003cbr /\u003e(Courriers, envois de paiements, retours...)'
export const CONTACT_DE_9H_18H = 'de 9h à18h'
export const CONTACT_DU_LUNDI_VENDREDI = 'Du lundi au vendredi'
export const CONTACT_JOUR_DISPO = 'Lundi au Vendredi de 9H à 18H.'
export const CONTACT_LE_SC_DISPO = 'Le service client est disponible par téléphone du lundi au vendredi de 9h à 17h.'
export const CONTACT_PAR_COURRIER = 'Par courrier'
export const CONTACT_PAR_MESSAGERIE = 'Par messagerie'
export const CONTACT_PAR_TELEPHONE = 'Par téléphone'
export const CONTACT_POUR_VOS_RETOURS_PAIEMENT_COURRIERS = 'Pour vos courriers, envois de paiements, retours...'
export const CONTACT_SERVICE_CLIENT_DISPO = 'Le service client est disponible '
export const CONTACT_THEME_MESSAGE = 'Thème de votre message'
export const CONTACT_VOTRE_MESSAGE = 'Votre message'
export const CONTACTEZ_NOUS = 'Contactez-nous'
export const CONTACTEZ_NOUS_TELEPHONE = 'Contactez nous par téléphone :'
export const CONTACTSERVICECLIENT = 'Contactez notre service client : 0 892 186 818'
export const CONTINUER_MAJ = 'CONTINUER'
export const CONTINUER_MES_ACHATS = 'Continuer mon shopping'
export const CONTINUER_MON_SHOPPING = 'Continuer mon shopping'
export const CORNERS = 'Corners'
export const COULEUR = 'Couleur'
export const COULEURS = 'Couleurs'
export const COULEURS_FAVORITES = 'Couleurs favorites'
export const COUP_DE_COEUR = 'Coup de coeur'
export const CREATIONALERTE = 'Créer votre alerte'
export const CREER_ALERTE = 'Créer votre alerte'
export const CREER_CE_PROFIL = 'Créer ce profil'
export const CREER_MON_COMPTE = 'Créer mon compte'
export const CREER_UN_COMPTE = 'Créer un compte'
export const CREER_UNE_ALERTE = 'CRÉER UNE ALERTE'
export const CREEZ_UNE_ALERTE = 'Créez une alerte'
export const CREEZ_VOTRE_ALERTE = 'Créez votre alerte !'
export const D_ACHAT = ' d\u0027achat'
export const DANS_LE_CAS_RETOUR_MR = 'Dans le cas d\u0027un retour par Mondial Relay, collez le code barre sur le colis, par dessus l\u0027étiquette de livraison.'
export const DATE = 'Date'
export const DATE_COMMANDE_MAJ = 'DATE DE LA COMMANDE'
export const DATE_DE_COMMANDE = 'Date de la commande'
export const DATE_DE_LIVRAISON_ESTIME = '\r\n        Date de livraison estimée :\r\n    '
export const DATE_DE_NAISSANCE = 'Date de naissance'
export const DATE_EXPIRTATION = 'Date d\u0027expiration'
export const DATE_FACTURE_MAJ = 'DATE DE LA FACTURE'
export const DATERETOUR = 'Date de retour'
export const DE = 'de'
export const DE_LA_MEME_MARQUE = 'De la même marque...'
export const DE_REDUCTION = 'de réduction'
export const DE_SPACE_MAJ = 'DE '
export const DE_STYLE = ' de style '
export const DECONOMIE = 'd\u0027économie'
export const DECOUVREZ_D_AUTRES_BONNES_AFFAIRES = 'D\u0026eacute;couvrez d\u0026apos;autres bonnes affaires !'
export const DECOUVREZ_D_AUTRES_TITLE = 'D\u0026eacute;couvrez d\u0026apos;autres '
export const DECOUVREZ_LOFFRE_DU_MOMENT = 'Découvrez l\u0027offre du moment :'
export const DECOUVRIR = 'Découvrir'
export const DECOUVRIR_ARTICLES_SIMILAIRES = 'Découvrir les articles similaires'
export const DECOUVRIR_CE_SERVICE = 'Découvrir ce service'
export const DECOUVRIR_LA_SUITE = 'Découvrir la suite'
export const DECOUVRIR_LOFFRE = 'Découvrir l\u0027offre'
export const DECOUVRIR_LOOKBOOK = 'Découvrir le Lookbook'
export const DECOUVRIR_MA_SELECTION = 'Découvrir ma sélection'
export const DEDUISEZ_VOTRE_AVOIR = 'Déduisez votre avoir'
export const DEDUISEZ_VOTRE_AVOIR_DE = 'Je déduis mon avoir, montant total disponible de'
export const DEDUISEZ_VOTRE_AVOIR_PDESIGN_LIVRAISON = 'Je déduis mon avoir, montant total disponible de'
export const DEDUISEZ_VOTRE_BON_ACHAT_DE = 'Déduisez votre bon d\u0027achat de'
export const DEDUISEZ_VOTRE_BON_ACHAT_PDESIGN_LIVRAISON = 'Je déduis mon bon d\u0027achat, montant total disponible de'
export const DEFAULT_PROFILNAME = 'Votre nom...'
export const DEJA_CLIENT = 'Déjà client'
export const DELAI = 'Délai'
export const DÉLAIS_DE_LIVRAISON = 'Délais de livraison'
export const DEMAIN = 'demain'
export const DEMANDE_DE_RETOUR_ARTICLE = 'Demande de retour d\u0027article'
export const DEMANDE_PARRAINAGE_PRIS_EN_COMPTE = 'Votre demande a bien été prise en compte'
export const DEMANDEZ_UN_REMBOURSEMENT = 'Demandez un remboursement'
export const DERNIERES_HEURES = 'Dernières heures'
export const DERNIERS_JOURS = 'Derniers jours'
export const DÈS = ' dès '
export const DES_100E_DACHAT = 'dès 100€ d\u0027achat'
export const DES_BOUTIQUES_DE_MODE = 'des boutiques de mode'
export const DES_LA_RECEPTION_DE_VOTRE_COLIS_RS = 'Dès la rèception de votre colis, n\u0027hesitez pas à partager vos coups de coeur et inspirer notre communauté en\r\n            identifiant @modz.fr !'
export const DES_QUESTIONS_ENVIES = 'Des questions, des envies ?'
export const DES_RECEPTION_DE_MON_COLIS = 'Dès réception de mon colis, le Service Retour crédite immédiatement mon compte Modz.'
export const DESACTIVE = 'Désactivé'
export const DESC_RETOUR_19 = 'Merci de préciser l\u0027erreur :'
export const DESC_RETOUR_21 = '💡 La taille sur l\u0027étiquette peut différer de celle commandée car nous effectuons une correspondance en taille française.\u003cbr/\u003eNous vous conseillons d\u0027essayer l\u0027article avant de le retourner.'
export const DESC_RETOUR_3 = 'Merci de préciser ce qu\u0027il manque :'
export const DESC_RETOUR_9 = 'Merci de préciser le défaut :'
export const DESCRIPTION = 'DESCRIPTION'
export const DESCRIPTION_MODZ_ALERTE = 'Modz vous propose des articles de déstockage en provenance de boutiques de mode. Chaque article est une pièce quasi unique, disponible en quelques tailles seulement. Cette rareté nous permet de vous proposer des prix cassés toute l\u0027année, même en dehors des soldes !'
export const DESCRIPTION_PROBLEME = 'Veuillez renseigner votre adresse e-mail et décrire votre problème :'
export const DESCRIPTION_PROBLEME_SHORT = 'Nature de votre problème :'
export const DESCRIPTION_UTILISATION_ALERTE = 'Pour être tenu(e) informé(e) par e-mail des arrivages correspondant à votre recherche, rien de plus simple !'
export const DESIGNATION = 'Désignation'
export const DESIGNATION_VENDEUR = 'Désignation vendeur'
export const DETAIL_COMMANDE = 'Détail de ma commande'
export const DETAIL_DE = 'Détail de '
export const DETAILS = 'Détails'
export const DETAILS_DE_MA_COMMANDE = 'Détails de ma commande'
export const DETAILS_PROBLEME = 'Que s’est-il produit ? Donnez-nous les détails de votre problème.'
export const DIMANCHE = 'Dimanche'
export const DISPO_SOUS_24H = 'Disponible sous 24h'
export const DISTRIBUE = 'Distribué'
export const DOMMAGE_EX = 'Dommage !'
export const DU = 'Du'
export const DUN_AVOIR_OU = 'd\u0027un avoir ou'
export const DUN_REMBOURSEMENT = 'd\u0027un remboursement'
export const ECONOMISEZ = 'économisez'
export const ECONOMISEZ_CATALOGUE = 'Économisez'
export const EFFACER_LES_FILTRES = 'Effacer les filtres'
export const EFFACER_TOUS_LES_FILTRES = 'Effacer tous les filtres'
export const EFFECTUEZ_UN_RETOUR = 'Effectuez un retour'
export const ELEGANTE_FP = 'élégantes'
export const EMAIL_COMPTE_CLIENT = 'Adresse email du compte client'
export const EMBALLAGE_CADEAU = 'Emballage Cadeau'
export const EN = 'En'
export const EN_ATTENTE_DEXPÉDITION = 'EN ATTENTE D\u0027EXPÉDITION'
export const EN_BON_DACHAT = 'en bon d\u0027achat'
export const EN_CLIQUANT_SUR_COMMANDER_JACCEPTE_LES_CGV = 'En cliquant sur Commander, j\u0027accepte les \u003ca href=\"/reassurance/cgv/\" target=\"_blank\" class=\"underline\"\u003eConditions Générales de Vente\u003c/a\u003e.'
export const EN_CLIQUANT_SUR_VALIDER_VOUS_REVEREZ_NOS_NEWS = 'En cliquant sur VALIDER, vous recevrez nos actus et nos offres'
export const EN_COURS_ACHEMINEMENT = 'En cours d\u0027acheminement'
export const EN_COURS_DE_LIVRAISON = 'En cours de livraison'
export const EN_COURS_DE_PRÉPARATION = 'En cours de préparation'
export const EN_DETAILS = 'En Détails'
export const EN_FONCTION_MODE_RETOUR = 'En fonction du mode de retour choisi (étape 1), déposez le colis dans un bureau de Poste ou en Point relais.'
export const EN_PISTE = 'Allez, hop, en piste.'
export const EN_RENSEIGNANT_DATE_ANNIVERSAIRE = 'En renseignant votre date d’anniversaire, nous ne manquerons pas de fêter ce bel évènement, comme il se doit !'
export const EN_SAVOIR_PLUSSYMBOLE = 'En savoir +'
export const EN_STOCK = 'EN STOCK'
export const EN_STOCK_EXPEDIE_24_H = 'En stock, Expédié en 24H'
export const EN_STOCK_LIVRE_LE = 'En stock, livré le'
export const ENCAISSE_RECEPTION = 'encaissé à réception'
export const ENCAISSE_RECEPTION_1MOIS = 'encaissé 1 mois après réception'
export const ENCAISSE_RECEPTION_2MOIS = 'encaissé 2 mois après réception'
export const ENCEMOMENT = 'En ce moment '
export const ENFANT = 'Enfant'
export const ENFANTS = 'Enfants'
export const ENFANTS_MAJ = 'ENFANTS'
export const ENGAGEMENTS = 'Engagements'
export const ENGAGEMENTSATISFACTION = 'Engagement Satisfaction'
export const ENREGISTER_LA_CARTE = 'Je souhaite enregistrer mes coordonnées carte pour un futur achat'
export const ENREGISTRER = 'Enregistrer'
export const ENREGISTRER_MA_CARTE_CADEAU = 'Enregistrer ma carte cadeau'
export const ENREGISTRER_MODIFICATIONS = 'Enregistrer les modifications'
export const ENREGISTRER_NOUVEAU_PASS = 'Enregistrer mon nouveau mot de passe'
export const ENREGISTRERIBAN = 'Enregistrer mon IBAN'
export const ENSAVOIRPLUS = 'En savoir plus'
export const ENSEMBLE = 'Ensemble'
export const ENTRE = 'Entre'
export const ENVIRON_ABREGES_MIN = 'env.'
export const ENVOI_LIEN_CONEXION = '(un lien de connexion vous sera envoyé)'
export const ENVOYER = 'Envoyer'
export const ENVOYER_CHEQUE_ADRESSE = 'et de les envoyer à l\u0027adresse suivante :'
export const ENVOYER_MA_DEMANDE = 'Envoyer ma demande'
export const ENVOYER_RAPPORT_INCIDENT = 'Envoyer le rapport d\u0027incident'
export const ENVOYER_VOTRE_MESSAGE = 'Envoyer votre message'
export const EPUISE_LE_LE_VEUX = 'Epuisé, je le veux !'
export const ERREUR_TYPE_PIECE_JOINTE = 'Seulement les fichiers de type \u0027.jpg\u0027 , \u0027.jpeg\u0027, \u0027.png\u0027 et \u0027.pdf\u0027 sont autorisés'
export const EST_EN_COURS_DE_TRAITEMENT = 'est en cours de traitement. Un e-mail de confirmation vient également de vous être envoyé sur votre boîte mail'
export const ESTATUTPAIEMENT_ANNULE = 'ANNULÉE'
export const ESTATUTPAIEMENT_ATTENTE_DE_PAIEMENT = 'EN ATTENTE DE PAIEMENT'
export const ESTATUTPAIEMENT_ATTENTE_DE_VALIDATION = 'EN ATTENTE DE VALIDATION'
export const ESTATUTPAIEMENT_PAYE = 'PAYÉE'
export const ESTATUTPAIEMENT_REFUSE = 'REFUSÉE'
export const ET = 'et'
export const ET_AUSSI = 'Et aussi ...'
export const ET_FAITES_PROFITER_DE_15E_DE_BA_A_VOS_FILLEULS = 'et faites profiter de 15€ de bon d’achat à vos filleuls !'
export const ET_SUIVEZ_NOTRE_ACTU = 'et suivez notre actualité shopping et bons plans !'
export const ET_TOUTE_LANNEE = 'et toute l\u0027année'
export const ETAPES = 'Etapes'
export const ETAT = 'Etat'
export const ETAT_DES_ARTICLES = 'L\u0027Etat du ou des articles'
export const ETAT_PARRAINAGE = 'Etat du parrainage'
export const EXCEPTIONNEL_LIVRAISON_OFFERTE = 'Exceptionnel : livraison offerte dès 100€ d\u0027achat'
export const EXCEPTIONNELLE_LIVRAISON_1EURO = 'Exceptionnel : livraison à 1€ dès 50€ d\u0027achat'
export const EXPEDIE_24_H = 'Expédié en 24h'
export const EXPEDIE_EN = 'Expédié en'
export const EXPEDIEE = 'EXPÉDIÉ'
export const EXPEDIER_COLIS_MAJ = 'EXPEDIER VOTRE COLIS'
export const EXPEDITION_EN_24H_MAJ = 'EXPEDITION EN 24 H'
export const EXPEDITION_IMMEDIATE = 'EXPÉDITION IMMÉDIATE'
export const EXPEDITION_RAPIDE = 'Expédition rapide'
export const EXPEDITION_RAPIDE_MAJ = 'EXPÉDITION RAPIDE'
export const EXPIRE_LE = 'Expire le'
export const EXPRESS = 'express'
export const FACTURE = 'Facture'
export const FACTURE_CONDITIONSGENERALES_MAJ = 'CONDITIONS GENERALES :'
export const FACTURE_CONDITIONSGENERALES_TXT = 'Les conditions Générales de vente applicables à votre commande acceptées lors de l\u0027enregistrement sont disponibles sur simple demande auprès du vendeur.'
export const FACTURE_INFOS_DE_FACTURATION = 'Informations de Facturation'
export const FACTURE_INFOS_DE_LIVRAISON = 'Informations de Livraison'
export const FACTURE_LOI_RETOUR = 'Conformément à l\u0027article L.121-20 et suivants du Code de la Consommation, vous disposez d\u0027un délai de 14 jours à compter de la date de livraison de votre commande pour retourner tout article ne convenant pas. L\u0027exercice de ce droit de rétractation est LIBRE sans avoir à justifier de motif ni à payer de pénalités. Les modalités précises de retour sont indiquées dans les conditions générales de vente de chaque vendeur.'
export const FACTURE_MODE_EXPEDITION = 'Mode d\u0027expédition'
export const FACTURE_TYPE_PAIEMENT = 'Type de paiement'
export const FAMILLES = 'Famille(s) :'
export const FAMILLESMOB = 'Familles'
export const FAVORIS = 'Favoris'
export const FDP_A_MAJ = 'FRAIS DE PORT À'
export const FDP_OFFERTS_AVEC_MR_A_PARTIR_DE_MAJ = 'FRAIS DE PORT OFFERTS AVEC MONDIAL RELAY À PARTIR DE'
export const FEMME = 'Femme'
export const FEMME_MAJ = 'FEMME'
export const FERME = 'Fermé'
export const FERMER = 'Fermer'
export const FERMER_MAJ = 'FERMER'
export const FILLE = 'Fille'
export const FILLE_MAJ = 'FILLE'
export const FILLES = 'Filles'
export const FILTRECATEGORIE = 'Sous-catégories'
export const FILTRECOULEUR = 'Couleurs'
export const FILTREFAMILLE = 'Catégories'
export const FILTREMARQUE = 'Marques'
export const FILTRER = 'Filtrer'
export const FILTRER_ET_TRIER = 'Filtrer et trier'
export const FILTRES = 'Filtres'
export const FILTRES_SELECTIONNES = 'Filtres sélectionnés :'
export const FOOTER_AVIS_VERIFIE_NOS_CLIENTS_NOUS_FONT_CONFIANCE = 'Nos clients nous font confiance'
export const FOOTNEWS_RECEVEZ_TOUTES_NOS_OFFRES = 'Recevez toutes nos offres, coups de coeur et nouveautés par mail en vous inscrivant à notre newsletter :'
export const FRAIS_LIVRAISON_ÉSTIMÉS_AVEC = 'Frais de livraison estimés avec'
export const FRAIS_LIVRAISON_ÉSTIMÉS_MR = 'Frais de port estimés Mondial Relay'
export const FRAISDELIVRAISON = 'Frais de livraison'
export const FRAISDEPORT = 'Frais de Port'
export const FRAISPORTOFFERT_PRODUIT = 'En ce moment,\u003cstrong class=\"pink\"\u003efrais de port offerts dès {0} €\u003c/strong\u003e avec Mondial Relay sur tout le site'
export const FRAISPORTREDUIT_PRODUIT = 'En ce moment,\u003cstrong class=\"pink\"\u003efrais de port à {0} € dès {1} €\u003c/strong\u003e avec Mondial Relay sur tout le site'
export const FRANCE = 'France'
export const FRANCE_METROPOLITAINE = 'France métropolitaine'
export const GAGNEZ = 'Gagnez'
export const GARANTI = 'Garanti'
export const GARANTIE_100_MOINS_CHER = 'Garantie 100% moins cher'
export const GARANTIE_AVANT_NOEL = 'Garantie avant Noël'
export const GARANTIE_AVANT_REVEILLON = 'Garantie avant le Réveillon'
export const GARANTIE_MOINS_CHER_MAJ = 'GARANTIE MOINS CHER'
export const GARANTIE_SATISFAIT_OU_REMBOURSE = 'Garantie satisfait ou remboursé'
export const GARANTIE_SATISFAIT_OU_REMBOURSE_MAJ = 'GARANTIE SATISFAIT OU REMBOURSÉ'
export const GARCON = 'Garçon'
export const GARCON_MAJ = 'GARÇON'
export const GARCONS = 'Garçons'
export const GERER_ADRESSES_FACTU_LIV = 'Gérer mes adresses de livraison\r\n'
export const GERER_MES_ALERTES = 'Mes alertes nouveautés'
export const GERER_MES_PREFERENCES = 'Gérer mes préférences'
export const GERER_MON_PROFIL_ET_MES_TAILLES = 'Gérer mon profil et mes tailles'
export const GEREZ_MES_PREFERENCES = 'Gérez mes préférences \u003e'
export const GEREZ_VOS_ADRESSES = 'Gérez vos adresses de livraison et de facturation'
export const GO_MAJ = 'GO !'
export const GO_TOP_MAJ = 'HAUT'
export const GRATUIT = 'Gratuit'
export const GUIDE_DENIM_PARFAIT = 'Guide du denim parfait'
export const GUIDER_CHERCHER_PRODUITS = 'C\u0027est décidé, je me laisse guider ! Parce que oui, c\u0027est pas facile de chercher parmi plus de 200.000 produits en stock, Modz s\u0027occupe de me dénicher la perle rare... Allez, hop, en piste.'
export const GUIDER_CHERCHER_PRODUITS_RETOUR_LIGNE = 'C\u0027est décidé, je me laisse guider ! Parce que oui, c\u0027est pas facile de chercher parmi plus de 200.000 produits en stock, Modz s\u0027occupe de me dénicher la perle rare...'
export const HAUT = 'Haut'
export const HAUTS = 'Hauts'
export const HAUTS_MAJ = 'HAUTS'
export const HOMME = 'Homme'
export const HOMME_MAJ = 'HOMME'
export const IDEE_CADEAU = 'New'
export const IDENTIFICATION_MAJ = 'IDENTIFICATION'
export const IL_NE_VOUS_RESTE_PLUS_QUE = 'Il ne vous reste plus que'
export const IL_RESTE_PLUS_QUE = 'Il ne vous reste plus que'
export const IMAGE_PRODUIT = 'Image Produit'
export const IMPASSE_CHAVANNE = '1, Impasse De Chavanne - ZAC De Chavanne'
export const IMPORTANT = 'Important'
export const IMPR_BON_RETOUR_MAJ = 'IMPRIMER LE BON DE RETOUR'
export const IMPRIMER_FACTURE_MAJ = 'IMPRIMER LA FACTURE'
export const IMPRIMER_LE_BORDEREAU_DE_RETOUR = 'Imprimer le bordereau de retour'
export const IMPRIMER_MAJ = 'IMPRIMER'
export const IMPRIMEZ_BON_RETOUR = 'Imprimez votre bon de retour.'
export const INDIQUER_MAJ = 'INDIQUER'
export const INSCRIPTION = 'Inscription'
export const INSCRIRE_EMAIL = 'Adresse mail :'
export const INSCRIVANT_RECEVOIR_OFFRES = 'En vous inscrivant, vous recevrez les meilleures offres et les promotions Modz.fr'
export const INTEMPORELLE_FP = 'intemporelles'
export const JACCEPTE = 'J\u0027accepte'
export const JAI = 'J\u0027ai'
export const JAI_DEJA_COMPTE_CLIENT = 'J\u0027ai déjà un compte client'
export const JAI_UN_COMPTE = 'J\u0027ai un compte'
export const JAIME_ET_JE_PARTAGE = 'J\u0027aime et je partage'
export const JE_CHERCHE_POUR = 'Je cherche pour :'
export const JE_CRAQUE = 'JE CRAQUE !'
export const JE_DECOUVRE = 'Je découvre'
export const JE_LE_VEUX_MAJ = 'JE LE VEUX !'
export const JE_MABONNE = 'Je m\u0027abonne'
export const JE_ME_CONNECTE_A_MON_COMPTE = 'Je me connecte à Mon compte \u003e Mes retours et je suis la procédure de retour.'
export const JE_PARRAINE = 'Je parraine'
export const JE_REEXPEDIE_LE_COLIS_AVEC_LE_TRANSPORTEUR = 'Je réexpédie le colis avec le transporteur de mon choix : Colissimo, Mondial Relay...'
export const JE_RENSEIGNE_LES_TAILLES = 'Je renseigne les tailles :'
export const JE_SELECTIONNE_MA_CARTE_PAIEMENT = 'Je sélectionne ma carte de paiement :'
export const JE_SHOPPE_MAJ = 'JE SHOPPE !'
export const JE_SOUHAITE = 'Je souhaite'
export const JE_SUIS_NOUVEAU_CLIENT = 'Je suis nouveau client'
export const JE_VALIDE = 'JE VALIDE'
export const JECONOMISE = 'J\u0027économise'
export const JEN_PROFITE = 'J\u0027en profite'
export const JEN_PROFITE_MAJ = 'J\u0027EN PROFITE'
export const JESOUHAITEQUONMEREMBOURSE = 'Je souhaite qu\u0027on me rembourse'
export const JEUDI = 'Jeudi'
export const JOURS = 'jours'
export const JUSTE_POUR_MOI_OH_OUI_JE_MINSCRIS = 'juste pour moi ? Oh oui, je m\u0027inscris !'
export const JY_VAIS = 'J\u0027y vais !'
export const L_ENVOI_SE_FAIT_EN_24H = 'L\u0027envoi se fait en 24H'
export const LA_COMMUNAUTE_MAJ = 'LA COMMUNAUTÉ'
export const LADRESSE_DE_RETOUR = 'L\u0027adresse de retour'
export const LADRESSE_INDIQUER_COLIS = 'L\u0027adresse à indiquer sur votre colis est :'
export const LE_LES_ARTICLES_NE_DOIVENT = 'Le ou les articles ne doivent ni :'
export const LE_LES_ARTICLES_PLIES_EMBALLAGE_ORIGINE = 'Le ou les articles doivent etre pliés dans leur emballage d\u0027origine'
export const LE_MIN = 'le'
export const LE_PARRAINAGE_CHEZ_MODZ = 'Le Parrainage chez Modz'
export const LE_PRODUIT_NE_CONVIENT_PAS = 'Le produit ne me convient pas : je le remets dans son sachet rose.'
export const LES_CHAUSSURES_DE_LA_SAISON = 'LES CHAUSSURES DE LA SAISON'
export const LES_DERNIRES_ARRIVAGES_MAJ = 'LES DERNIERS ARRIVAGES'
export const LES_FACTURES_SONT_EN_EUROS = 'Les factures sont libellées en Euros.'
export const LES_MARQUES_A_LA_UNE = 'Les marques à la une'
export const LES_PLUS_BELLES_PEPITES_EN_SOLDES = 'Les plus belles pépites en soldes'
export const LIB_POPUP_PAIEMENT_CB = 'Merci de renseigner les informations suivantes pour vérifier votre éligibilité au paiement en'
export const LIENGUIDETAILLES = 'Guide des tailles'
export const LINGERIE = 'Lingerie'
export const LIVRAISON = 'LIVRAISON'
export const LIVRAISON_A = 'Livraison à'
export const LIVRAISON_A_DOMICILE_EXPRESS = 'Livraison à domicile express'
export const LIVRAISON_A_DOMICILE_STANDARD = 'Livraison à domicile standard'
export const LIVRAISON_EN_RELAIS_EXPRESS = 'Livraison en relais express'
export const LIVRAISON_EN_RELAIS_STANDARD = 'Livraison en relais standard'
export const LIVRAISON_EXPRESS_GARANTIE_AVANT_NOEL = 'Livraison express garantie avant Noël'
export const LIVRAISON_EXPRESS_POINT_RELAIS = 'Livraison EXPRESS en point relais'
export const LIVRAISON_GARANTIE_AVANT_NOEL = 'Livraison garantie avant Noël'
export const LIVRAISON_GARANTIE_AVANT_NOEL_AVEC_CHRONOPOST = 'Livraison garantie avant Noël avec Chronopost'
export const LIVRAISON_GARANTIE_AVANT_REVEILLON_AVEC_CHRONOPOST = 'Livraison garantie avant le Réveillon avec Chronopost'
export const LIVRAISON_GRATUITE_DES = 'Livraison gratuite dès'
export const LIVRAISON_GRATUITE_DES_100 = 'Livraison gratuite dès 100€ d\u0027achat'
export const LIVRAISON_MIN = 'livraison'
export const LIVRAISON_OFFERTE = 'Livraison offerte'
export const LIVRAISON_OFFERTE_DES_100 = 'Livraison offerte dès 100€'
export const LIVRAISON_OFFERTE_MAJ = 'LIVRAISON OFFERTE'
export const LIVRAISON_PAIEMENT_MAJ = 'Livraison et Paiement'
export const LIVRAISON_PAIEMENT_RETOUR = 'Livraison, paiement et retour'
export const LIVRAISON_PREVUE = 'Livraison prévue'
export const LIVRÉ = 'Livré'
export const LIVRER_AUTRE_ADRESSE_MAJ = 'LIVRER À UNE AUTRE ADRESSE'
export const LOOKBOOK = 'Lookbook'
export const LOOKBOOK_MAJ = 'LOOKBOOK'
export const LUNDI = 'Lundi'
export const LUNDI_AU_VENDREDI = 'lundi au vendredi'
export const LUXE = 'LUXE'
export const LUXE_FP = 'luxe'
export const M = 'M'
export const M_DOT = 'M.'
export const MA_COMMANDE = 'Ma commande'
export const MAINTENANT_MAJ = 'MAINTENANT !'
export const MARDI = 'mardi'
export const MARIAGE_CEREMONIE = 'Mariage et cérémonies'
export const MARQUE = 'Marque'
export const MARQUE_ACCESSOIRE_FEMME = 'Marques accessoires femme'
export const MARQUE_ACCESSOIRE_HOMME = 'Marques accessoires homme'
export const MARQUE_CHAUSSURE_FEMME = 'Marques chaussures femme'
export const MARQUE_CHAUSSURE_HOMME = 'Marques chaussures homme'
export const MARQUE_LINGERIE_FEMME = 'Marques lingerie femme'
export const MARQUE_LINGERIE_HOMME = 'Marques lingerie homme'
export const MARQUE_VETEMENTS_FEMME = 'Marques vêtements femme'
export const MARQUE_VETEMENTS_HOMME = 'Marques vêtements homme'
export const MARQUES = 'Marques'
export const MARQUES_DE_MODE_PAS_CHER = 'Marques de mode pas cher'
export const MARQUES_PREFEREES = 'Marques préférées'
export const MARQUESUNE = 'Marques à la une'
export const MASQUER_LES_HORAIRES = 'Masquer les horaires'
export const MATIEREENTRETIEN = 'Matières et entretien'
export const MATIERES = 'Matières'
export const MDP_ACTUEL = 'Mot de Passe actuel'
export const MDP_CONFIRMER = 'Confirmer le mot de passe'
export const MDP_NOUVEAU = 'Nouveau mot de passe'
export const ME_CONNECTER = 'Me connecter'
export const ME_DECONNECTER = 'Me déconnecter'
export const ME_MIN = 'me'
export const MERCI_PRECISER_DEFAUT = 'Merci de préciser le défaut :'
export const MERCI_PRECISER_ERREUR = 'Merci de préciser l\u0027erreur :'
export const MERCIMODZ = 'Merci Modz !'
export const MERCREDI = 'Mercredi'
export const MES_ALERTES = 'Mes alertes'
export const MES_ALERTES_NOUVEAUTES = 'Mes alertes nouveautés'
export const MES_AVOIR_ET_REMBOURSEMENT = 'Mes avoirs et remboursements'
export const MES_BONS_PARRAINAGE = 'Mes bons de parrainage'
export const MES_FAVORIS = 'Mes favoris'
export const MES_FILLEULS = 'Mes filleuls'
export const MES_INFOS_FACTURATION = 'Mes informations de facturation'
export const MES_INFOS_PERSONNELLES = 'Mes infos personnelles'
export const MES_INFOS_PERSOS = 'Gérer mon compte'
export const MES_TAILLES = 'Mes tailles'
export const MESSAGERIE = 'Messagerie'
export const MESSAGES = 'Messages'
export const MODE_FEMME = 'Mode femme'
export const MODE_HOMME = 'Mode homme'
export const MODIFIER = 'Modifier'
export const MODIFIER_ADRESSE = '\u003e\u003e modifier'
export const MODIFIER_ADRESSE_LIVRAISON = 'Modifier mon adresse de livraison'
export const MODIFIER_CE_PROFIL = 'Modifier ce profil'
export const MODIFIER_LE_CP = 'Modifier le code postal'
export const MODIFIER_MES_COULEURS_ET_MES_MARQUES = 'Modifier mes couleurs et mes marques'
export const MODIFIER_MES_TAILLES = 'Modifier mes tailles'
export const MODIFIEZ_ADRESSES_PERSOS = 'Vous pouvez modifier ci-dessous à tout moment vos données personnelles: vos coordonnées, email et mot de passe.'
export const MODZ = 'Modz'
export const MODZ_AVIS = 'MODZ Avis'
export const MODZ_REMBOURSE_10_FOIS_LA_DIFF = 'Modz rembourse 10 fois la différence'
export const MOINS_50_SUR_TOUT_LE_SITE_MAJ = '-50% SUR TOUT LE SITE'
export const MON_ADRESSE_LIVRAISON = 'Mon adresse de livraison'
export const MON_COMPTE = 'Mon compte'
export const MON_PANIER = 'Mon Panier'
export const MON_PANIER_MAJ = 'MON PANIER'
export const MON_PROFIL = 'Mon profil'
export const MON_PROFIL_ET_MES_TAILLES = 'Mon profil et mes tailles'
export const MON_SHOPPING_PERSONNALISE = 'Mon shopping personnalisé'
export const MONTANT = 'Montant'
export const MONTANT_COMMANDE = 'Montant de ma commande'
export const MONTANT_INITIAL = 'Montant initial'
export const MONTANT_MINI_ACHAT = 'Montant minimum d\u0027achat'
export const MONTANT_PAYE = 'Montant Payé'
export const MONTANT_RESTANT = 'Montant restant'
export const MONTANT_TOTAL = 'Montant Total'
export const MONTANTTVA = 'Montant TVA'
export const MOT_PASSE = 'Mot de passe'
export const MOT_PASSE_OUBLIE = 'Mot de passe oublié ?'
export const MOTIF = 'Motif'
export const N1_DU_DESTOCKAGE = 'N°1 du déstockage'
export const NATURE_MESSAGE = 'Nature de votre message'
export const NATURE_PROBLEME = 'La nature de votre problème : souci de connexion, problème sur votre panier, erreur de serveur…'
export const NAVIGATION = 'Navigation'
export const NAVIGATION_PRECEDENT = '\u003c\u003c   Précédent '
export const NAVIGATION_RETOUR_LISTE = '\u003c\u003c RETOUR À  LA LISTE'
export const NAVIGATION_SUIVANT = ' Suivant   \u003e\u003e'
export const NB_ARTICLES_CONCERNES_RETOUR = 'Nombre d\u0027articles concernés par le retour :'
export const NBR_TAILLES_UTILISÉES = 'Les tailles de votre profil ont été utilisées pour cette alerte.'
export const NE_ETRANGER_COCHEZ = 'Né(e) à l\u0027étranger, cochez ici :'
export const NEST_DESORMAIS_PLUS_DISPO = 'n\u0027est désormais plus disponible.'
export const NEUFH_DIXHUITH = '9h à 18h'
export const NEW = 'New'
export const NEWSDESTYLE = 'News de style'
export const NI_ETRE_SALI = '- Ni être sali'
export const NI_LAVE = '- Ni lavé'
export const NI_REPASSE = '- Ni repassé'
export const NOM = 'Nom'
export const NOM_TITULAIRE_CARTE = 'Nom du titulaire de la carte'
export const NON = 'Non'
export const NON_MERCI_PLUS_TARD = 'Non merci, plus tard'
export const NON_RENSEIGNEES = 'Non renseignées'
export const NOS_ARRIVAGES_MAJ = 'NOS ARRIVAGES'
export const NOS_CLIENTS_RECOMMANDENT_MODZ = 'Nos clients recommandent Modz'
export const NOS_MARQUES = 'Nos marques'
export const NOS_MARQUES_SELECTIONNEES = 'Nos marques sélectionnées'
export const NOS_PLUS_BEAUX_PULLS_JACQUARD = 'Nos plus beaux pulls en jacquard'
export const NOS_SUGGESTIONS = 'Nos suggestions'
export const NOSASTUCES = 'Nos astuces'
export const NOTRE_SERVICE_CLIENT_EST_A_VOTRE_ECOUTE = 'Notre service client est à votre écoute du'
export const NOUS_ENVERRONS_LIEN_RÉINITIALISER_MOT_PASSE = 'Nous vous enverrons par e-mail un lien qui vous permettra de réinitialiser votre mot de passe.'
export const NOUS_ESPERONS_AVOIR = 'Nous espèrons avoir bientôt de vos nouvelles !'
export const NOUVEAU_CLIENT = 'Nouveau client'
export const NOUVEAU_MAJ = 'NOUVEAU'
export const NOUVEAU_SERVICE_CLICK_COLLECT = 'Notre nouveau service Click \u0026 Collect !'
export const NOUVEAUTES = 'Nouveautés'
export const NOUVEAUTES_AH_50 = 'Nouveautés Automne-Hiver à -50%'
export const NOUVEAUTES_COLOREES = 'Nouveautés colorées !'
export const NOUVEAUX_ARRIVAGES = 'Soyez le 1er informé des nouveaux arrivages'
export const NOUVELLE_RECHERCHE_IA = 'Nouvelle recherche'
export const NUM_FACTURE_MAJ = 'N° DE FACTURE'
export const NUMENVOI = 'Numéro d\u0027envoi'
export const NUMERO_TELEPHONE_TRANSPORTEUR_INFORME = 'Votre numéro de téléphone permettra au transporteur de vous tenir informé'
export const NUMRETOUR = 'N° de retour'
export const OFFERT = 'Offert'
export const OFFERT_MAJ = 'OFFERT'
export const OFFERTE = 'offerte'
export const OFFRE_SPECIALE = 'OFFRE SPECIALE'
export const OFFREZ_LEUR = 'Offrez leur'
export const OFFRIR_CARTE_CADEAU = 'Offrir la carte cadeau'
export const OFFRIR_UNE_CARTE = 'Offrir une carte'
export const OHLALA_JE_CRAQUE_MAJ = 'OH LA LA, JE CRAQUE !'
export const OHNON = 'Oh non :('
export const OK = 'OK'
export const ORIGINAL_FP = 'originales'
export const OU = 'ou'
export const OU_PAR_TELEPHONE = 'ou par téléphone au'
export const OUI = 'Oui'
export const PAIEMENT = 'PAIEMENT'
export const PAIEMENT_3X_4X_CB = 'Paiement en 3X ou 4X CB'
export const PAIEMENT_3X_OU_4X_CB = 'Paiement en 3x ou 4x CB'
export const PAIEMENT_ANNULE_MAJ = 'Paiement annulé'
export const PAIEMENT_MAJ = 'Paiement'
export const PAIEMENT_REFUSE_MAJ = 'Paiement refusé'
export const PAIEMENT_REFUSE_MAJ_CALL = 'Une erreur est survenue lors de l\u0027authentification du moyen de paiement. Nous vous invitons à contacter votre banque.'
export const PAIEMENT_REFUSE_MAJ_INFOS = 'Paiement refusé : \u003cbr/\u003eDes informations de votre compte semblent poser problème (nom, prénom, adresse de livraison ou de facturation), Nous vous invitons à les vérifier puis à retenter le paiement. Si le problème persiste, vous pouvez contacter le service client.'
export const PAIEMENT_REFUSE_MAJ_LONG = 'L\u0027authentification du moyen de paiement a été trop longue. Nous vous invitons à réessayer.'
export const PAIEMENT_REFUSE_MAJ_OTHER = 'Une erreur est survenue lors de l\u0027authentification du moyen de paiement. Nous vous invitons à utiliser un autre moyen de paiement.'
export const PAIEMENT_REFUSE_MAJ_RETRY = 'Une erreur est survenue lors de l\u0027authentification du moyen de paiement. Nous vous invitons à réessayer.'
export const PAIEMENT_SECURISE = 'Paiement sécurisé'
export const PAIEMENT_SECURISE_MAJ = 'PAIEMENT SÉCURISÉ'
export const PANIER = 'Panier'
export const PANIER_MAJ = 'PANIER'
export const PARRAINAGE_CINQEUROS_BONACHAT = '5 € en bon d\u0027achat'
export const PARRAINAGE_DES_PREMIER_ACHAT_AMI = 'Dès le premier achat de l\u0027un(e) de vos ami(e)s, vous bénéficiez d\u0027un bon d\u0027achat de'
export const PARRAINAGE_EMAIL_FILLEUL_1 = 'Adresse email du 1er filleul'
export const PARRAINAGE_EMAIL_FILLEUL_2 = 'Adresse email du 2ème filleul'
export const PARRAINAGE_EMAIL_FILLEUL_3 = 'Adresse email du 3ème filleul'
export const PARRAINAGE_EN_PARRAINANT_VOS_AMIES = 'En parrainant vos ami(e)s, vous leur offrez'
export const PARRAINAGE_PARRAINEZ_VOS_AMIS = 'Parrainez vos ami(e)s en inscrivant ci-dessous leurs adresses mails :'
export const PARRAINAGE_PARRAINEZ_VOS_AMIS_ENOYANT_INVITATION = 'Parrainez-vos ami(s) en leur envoyant une invitation.'
export const PARRAINAGE_POUR_LEUR_PREMIERE_COMMANDE = 'pour leur(s) première commande. Validité : 3 mois à partir de l\u0027inscription et dès 50 € d\u0027achat.'
export const PARRAINAGE_SAISISSEZ_EMAIL_FILLEUL = 'Saisissez l\u0027email de votre filleul'
export const PARRAINER = 'Parrainez !'
export const PARRAINER_AMIS = 'Parrainer mes amis'
export const PARRAINER_UN_AMI = 'Parrainer un ami'
export const PARRAINEZ_VOS_AMIS_GAGNEZ_20E = 'Parrainez vos amis, gagnez 20€'
export const PARRAINEZ_VOS_PROCHES = 'Parrainez vos proches'
export const PARTAGEZ_VOTRE_NOUVEAU_LOOK = 'Partagez votre nouveau look !'
export const PARTENARIAT = 'Partenariat'
export const PAS_DE_BLABLA = 'Pas de blabla, que des promos !'
export const PAS_VOTRE_TAILLE = 'Il n\u0027y a pas votre taille'
export const PASSEE_LE = 'Passée le'
export const PAYER = 'Payer'
export const PAYER_AVEC_CETTE_CARTE = 'Payer avec cette carte'
export const PAYER_CETTE_COMMANDE = 'Payer cette commande'
export const PAYPAL = 'Paypal'
export const PAYS = 'Pays'
export const PERSONNAL_SHOPPING = 'Personal shopping'
export const PHOTO = 'Photo'
export const PLACEZ_LES_ARTICLES = 'Placez le ou les articles ainsi que le bon de retour dans le colis.'
export const PLIE_EMBALLAGE_ORIGINE = '- Plié dans son emballage d\u0027origine'
export const PLUS_DE_11000_POINT_RELAIS_AU_CHOIX = 'Plus de 11 000 points relais au choix'
export const PLUS_DE_6000_POINT_RELAIS_AU_CHOIX = 'Plus de 7 000 points relais au choix.'
export const PLUS_DE_FILTRES = 'Plus de filtres'
export const POINT_RELAIS_STANDARD = 'Point relais standard'
export const POINTURES = 'Pointures'
export const POPUP_RETOUR_CHOIX_MODE_EXPE = 'Choisissez le mode d\u0027expédition de votre retour'
export const POPUP_RETOUR_COUT = 'Coût :'
export const POPUP_RETOUR_SHOPPING_TRANQUILLE = 'Vous bénéficiez de l\u0027option Shopping tranquille, votre retour est gratuit ! Sélectionnez un point Mondial Relay.'
export const PORTABLE = 'Portable'
export const POUR = 'pour'
export const POUR_BENEFICIER_DE_LA = 'pour bénéficier de la'
export const POUR_BENEFICIER_DE_LA_LIVRAISON_GRATUITE = 'pour bénéficier de la livraison gratuite.'
export const POUR_ENFANTS_MAJ = 'POUR ENFANTS'
export const POUR_ETRE_FACTURE_MODIFIER = 'Pour être facturé à une autre adresse, veuillez modifier vos informations'
export const POUR_ETRE_LIVRE_DEMAIN = 'pour être livré demain !'
export const POUR_ETRE_LIVRE_DEMAIN_AVEC_CHRONOPOST = 'pour être livré demain avec Chronopost !'
export const POUR_ETRE_LIVRER_MODIFIER_LIVRAISON = 'Pour être livrer à une autre adresse, veuillez modifier vos informations'
export const POUR_FEMME_MAJ = 'POUR FEMME'
export const POUR_HOMME_MAJ = 'POUR HOMME'
export const POUR_SAISIR_MANUELLEMENT_VOTRE_ADRESSE = 'pour saisir manuellement votre adresse'
export const POUR_SUIVRE_LE_BON_SENS_DE_LA_MODE = 'Pour suivre le bon sens de la mode, c\u0027est par ici !'
export const PREFERENCES = 'Préférences'
export const PRENOM = 'Prénom'
export const PREPAREE_EN_ATTENTE_DEXPÉDITION = 'PRÉPARÉ EN ATTENTE D\u0027EXPÉDITION'
export const PREPARER_MAJ = 'PREPARER'
export const PRESTATAIRE = 'Prestataire'
export const PRISE_EN_CHARGE = 'Prise en charge par le transporteur'
export const PRIX = 'Prix'
export const PRIX_BOUTIQUE = 'Prix boutique'
export const PRIX_BOUTIQUE_CATALOGUE = 'Prix Boutique : '
export const PRIX_MODZ_CATALOGUE = 'Prix Modz '
export const PRIX_TOTAL_MAJ = 'PRIX TOTAL'
export const PRIX_UNITAIRE_MAJ = 'PRIX UNITAIRE'
export const PRIXSERVICECLIENT = '0,35 cts/min'
export const PROBLEME_TECHNIQUE_CONNEXION = 'Si votre problème technique n’est pas un problème de connexion, nos techniciens vous apporteront une solution personnalisée dans les plus brefs délais.'
export const PRODUIT = 'Produit'
export const PRODUIT_EPUISE = 'Produit épuisé'
export const PRODUITS = 'Produits'
export const PROFILE = 'Profile'
export const PROLONGATION_JUSQU_AU = 'PROLONGATION JUSQU\u0027AU 24.05.19'
export const PROMO = 'Promo'
export const PROMO_CATALOGUE = 'Promotion'
export const PROMOS = 'Promos'
export const PROMOTION = 'Promotion'
export const PROPOSITIONS = 'Propositions'
export const QTE_MAJ = 'QTE'
export const QUANTITE_LIMITEE = 'Quantité limitée'
export const QUATORZE_JOURS_POUR_RENVOYER_VOS_ARTICLES = '14 jours pour renvoyer vos articles.'
export const QUATRE_JOURS_SEULEMENT = '4 JOURS SEULEMENT !'
export const QUEL_NAVIGATEUR = 'Quel est votre navigateur ? (Google Chrome, Internet Explorer, Mozilla Firefox…)'
export const QUINZE_EUROS = '15€'
export const QUOIDENEUF = 'Quoi de neuf ?'
export const RAPPEL_CRITERES_ALERTE = 'Rappel de vos critères d\u0027alerte :'
export const RAPPORT_ENVOI_MAIL = 'Un mail vient de vous être envoyé. Il contient un lien qui pourra résoudre un éventuel problème de connexion.'
export const RAPPORT_INCIDENT_EMAIL_INCORRECT = 'L\u0027email renseigné ne correspond à aucun compte client.'
export const RAPPORT_INCIDENT_SOUMIS = 'Votre demande a bien été envoyée.'
export const RECEVOIR_TOUTES_NOS_ACTUS_OFFRES = 'Recevoir toutes nos actus et nos offres'
export const RECHERCHER = 'Rechercher'
export const RECHERCHER_UNE_MARQUE = 'Rechercher une marque...'
export const RECOMMANDATION_PRODUIT = 'Recommandation produit'
export const REDUCTION = 'Réduction'
export const REF = 'Réf'
export const REF_CLIENT_MAJ = 'REFERENCE CLIENT'
export const REF_COMMANDE_MAJ = 'REFERENCE COMMANDE'
export const REF_MODELE = 'Ref Modèle'
export const REF_PRODUIT = 'Ref Produit'
export const REFERENCE = 'Référence'
export const REFERENCE_CLIENT = 'Référence client :'
export const REFERENCE_NUMBER = 'Référence n°'
export const REINITIALISER = 'Réinitialiser'
export const REINITIALISEZ_VOTRE_PASSWORD = 'Réinitialisez votre mot de passe : '
export const REJOIGNEZ_COMMU_FACEBOOK = 'Rejoignez la communauté Facebook'
export const RELAIS_STANDARD = 'Relais standard'
export const REMBOURSE_2X = 'remboursé 2x'
export const REMBOURSEMENT_DIFFERENCE = 'nous vous remboursons la différence'
export const REMBOURSEMENTENCOURS = 'Remboursement en cours'
export const REMISE_SUR_ARTICLES = 'Remise sur articles'
export const REMISES = 'Remises'
export const RENSEIGNER_NUMERO_CHEQUE = 'Merci de renseigner le numéro de commande au dos du chèque.'
export const RENSEIGNEZ_LES_TAILLES_MAJ = 'RENSEIGNEZ LES TAILLES'
export const RESTANTDUTTC = 'Restant dû TTC'
export const RESTE_A_PAYER = 'Reste à payer'
export const RESULTAT = 'Résultat'
export const RESULTAT_RECHERCHE_IA = 'Résultat de votre recherche'
export const RESULTATS = 'Résultats :'
export const RESULTATS_DE_VOTRE_RECHERCHE = 'Resultats de votre recherche'
export const RESULTATS_TROUVES = 'Résultats trouvés'
export const RETOUR = 'RETOUR'
export const RETOUR_A_TOUS_MES_PROFILS = 'Retour à tous mes profils'
export const RETOUR_ADRESSER_MAJ = 'RETOURS A ADRESSER A :'
export const RETOUR_DESPOSER_POINT_MR = 'RETOUR A DEPOSER AU POINT RELAIS :'
export const RETOUR_FACILE_SANS_CONDITION = 'Retour facile sans condition'
export const RETOUR_FACILE_SANS_CONDITION_MAJ = 'RETOUR FACILE SANS CONDITION'
export const RETOUR_HAUT_DE_PAGE = 'Retour haut de page'
export const RETOUR_HAUT_DE_PAGE_MAJ = 'RETOUR HAUT DE PAGE'
export const RETOUR_PAGE_ACCUEIL = 'Retour à la page d\u0027accueil'
export const RETOURNER_ARTICLE_FACE = 'RETOURNER UN ARTICLE C\u0027EST FACILE ET RAPIDE EN 5 ÉTAPES'
export const RETOURNERUNARTICLE = 'Retourner un article'
export const RETROUVEZ_ARTICLES_SELECTION_PERSO = 'Retrouvez tous vos articles de votre sélection personnalisée.'
export const RETROUVEZ_INFOS_PERSOS_COMDES = 'Retrouvez toutes les informations sur vos données personnelles et vos commandes.'
export const ROCK_FP = 'Rock \u0026 Denim'
export const SABONNER_A_LA_NEWS = 'S\u0027abonner à la newsletter'
export const SABONNER_À_NOTRE_PAGE = 'S’abonner à notre page'
export const SACS_ACCESSOIRES_MAJ = 'SACS \u0026 ACCESSOIRES'
export const SAISIE_EMAIL = 'Saisissez votre adresse e-mail'
export const SAISIEIBAN = 'Saisie de votre IBAN :'
export const SAISIR_LE_CODE = 'Saisir le code'
export const SAISISSEZ_ADRESSE_MAIL = 'Saisissez votre adresse mail'
export const SAISISSEZ_MAIL_CLIQUEZ_CONTINUER = 'Saisissez l’adresse e-mail que vous utilisez habituellement pour vous connecter à Modz et cliquez sur continuer.'
export const SAISISSEZ_NOUVEAU_PASS = 'Saisissez votre nouveau mot de passe'
export const SAMEDI = 'Samedi'
export const SAUVEGARDER = 'Sauvegarder'
export const SE_CONNECTER_AVEC_GOOGLE = 'Se connecter avec Google'
export const SE_DECONNECTER = 'Se déconnecter'
export const SE_SOUVENIR_MOI = 'Se souvenir de moi'
export const SELECTION_CADEAUX_POUR_ELLE = 'Sélection cadeaux pour elle'
export const SELECTION_CADEAUX_POUR_LUI = 'Sélection cadeaux pour lui'
export const SELECTION_PERSONNALISEE = 'Ma sélection personnalisée'
export const SELECTIONNER_COULEUR_FILTRES = 'Sélectionner une couleur'
export const SELECTIONNEZ_POINT_RELAIS = 'Sélectionnez un point relais'
export const SELECTIONNEZ_VILLE = 'Sélectionnez votre ville'
export const SELECTIONNEZ_VOTRE_POINT_CHRONOPOST = 'Sélectionnez votre point Chronopost'
export const SELECTIONNEZ_VOTRE_POINT_RELAY = 'Sélectionnez votre point Mondial Relay.'
export const SELECTIONNEZ_VOTRE_TAILLE = 'Sélectionnez votre taille'
export const SELECTIONS_SPECIALES = 'Sélections Spéciales'
export const SERVER_SECURISE = 'SERVEUR SÉCURISÉ'
export const SERVEUR_SÉCURISE = 'SERVEUR SÉCURISÉ'
export const SERVICE_CLIENT = 'SERVICE CLIENT'
export const SERVICE_CLIENT_DISPONIBLE = 'Le service client est disponible du :'
export const SERVICE_CLIENT_HORAIRE = 'Lundi au Vendredi de 9H00 à 18H00.'
export const SERVICE_MARKETING = 'Service marketing'
export const SESAME_OUVRE_TOI = 'Sésame ouvre toi'
export const SHOOPING_TRANQUILLE = 'Shopping tranquille'
export const SI_VOUS_AVEZ_UN_CODE_PROMO = 'Si vous avez un code promotionnel, veuillez le saisir ici :'
export const SI_VOUS_NE_RECEVEZ_PAS = 'Si vous ne recevez pas cet e-mail, vérifiez alors vos courriers indésirables ou contactez l’un de nos conseillers au 0892 186 818 (0,35€/min)'
export const SI_VOUS_SOUHAITEZ_ANNULER_VOTRE_COMMANDE = 'Si vous souhaitez annuler votre commande, merci de le signaler au service client en'
export const SI_VOUS_SOUHAITEZ_REGLER_VOTRE_COMMANDE = 'Si vous souhaitez régler votre commande par un autre moyen de paiement, cliquez sur'
export const SOLDES = 'Soldes'
export const SOLDESAVOIRS = 'Solde des avoirs'
export const SOLDESBONSACHAT = 'Solde des bons d\u0027achat'
export const SOUHAITEZ_RECEVOIR_OFFRES = 'Souhaitez-vous également recevoir les offres de partenaire de Modz :'
export const SOUS_48H = 'sous 48H'
export const SOUS_CATEGORIE = 'Sous-catégorie'
export const SOUS_TOTAL_ACHATS = 'Sous Total des achats ..................'
export const SOUSCATEGORIES = 'Sous-catégories'
export const SOUSTOTALTTC = 'Sous-total TTC'
export const SOYEZ_INFORME_DE_LETAT_DES_CMDES = 'Soyez informé de l\u0027état d\u0027avancement des commandes que vous avez réalisées, consultez l\u0027historique de vos commandes, imprimez vos factures ou annulez une commande en cours.'
export const SOYEZ_INFORME_DES_NOUVEAUTES_DE_LA_MARQUE = 'Soyez informé en avant-première des nouveautés de la marque !'
export const SPORT = 'Sport'
export const SPORTSWEAR_FP = 'sportswear'
export const STANDARD = 'standard'
export const STATUT = 'Statut'
export const STYLES = 'Styles'
export const SUIVANT = 'Suivant'
export const SUIVANT_MAJ = 'SUIVANT'
export const SUIVEZ_NOUS = 'Suivez-nous'
export const SUIVEZ_STATU_CMD = 'Suivez le statut de votre commande en cours'
export const SUIVEZ_VOS_RETOURS = 'Suivez vos retours'
export const SUIVI_DE_LIVRAISON = 'Suivi de livraison'
export const SUIVI_DE_MES_CMDES = 'Suivi de mes commandes'
export const SUIVI_DES_MESSAGES = 'Suivi des messages'
export const SUIVRE_MES_COMMANDES = 'Suivre mes commandes'
export const SUIVRE_MES_RETOURS = 'Retourner un article'
export const SUIVRE_VOTRE_RETOUR = 'Suivre votre retour'
export const SUPP = 'supp.'
export const SUPPRIMER = 'Supprimer'
export const SUPPRIMER_ARTICLE_PANIER = 'Supprimer un article du panier'
export const SUPPRIMER_LA_SELECTION = 'Supprimer la sélection'
export const SUPPRIMER_SELECTION = 'Supprimer ma sélection'
export const SUR_VOTRE_COLIS = 'sur votre colis'
export const T_DOT = 'T.'
export const TAILLE = 'Taille'
export const TAILLE_BAS = 'Tailles de bas'
export const TAILLE_CONVERTIE_SELON_STANDARD = '*Taille convertie selon les standards de tailles françaises.'
export const TAILLE_ETIQUETTE = 'Taille étiquette'
export const TAILLE_HAUT = 'Tailles de haut'
export const TAILLE_MARUE_ETIQUETEE_PRODUIT = '** Taille de la marque étiquetée sur le produit.'
export const TAILLE_MAXIMUM_PIECE_JOINTE_1MO = 'La taille maximum pour votre pièce jointe ne doit pas dépasser 1 Mo'
export const TAILLEDISPO_PRODUIT = 'Taille(s) Disponible(s)'
export const TAILLEDISPO_PRODUIT_SING = 'Taille Disponible'
export const TAILLEFRANCAISE = 'Taille\u003cbr /\u003eFrançaise'
export const TAILLEMARQUE = 'Taille(s) Étiquette'
export const TAILLES = 'Tailles'
export const TAILLES_DE = 'Taille de'
export const TAILLES_DE_BIS = 'Tailles de'
export const TAILLES_DISPOS = 'Tailles disponibles'
export const TAILLES_PRODUIT_DISPO_CATALOGUE = 'Tailles dispo : '
export const TAILLES_SELECTIONNEES = 'taille(s) sélectionnée(s)'
export const TAILLESDISPOS_PRODUIT = 'Tailles disponibles'
export const TARIFTTC = 'Tarif TTC'
export const TELECHARGEMENT_ETIQUETTE = 'Imprimer l’étiquette'
export const TELECHARGEZ_IMPRIMER_BORDEREAU_RETOUR_MAJ = 'TELECHARGEZ ET IMPRIMEZ LE BORDEREAU DE RETOUR A JOINDRE DANS VOTRE COLIS'
export const TELECOPIE = 'Télécopie'
export const TELEPHONE = 'Téléphone'
export const TENDANCE_FP = 'tendances'
export const TENUES_DE_FETES = 'Tenues de fêtes'
export const TEST13M_CHEZ_MODZ_CEST_LA_JUNGLE = 'Chez Modz, \u003cspan class=\"visible-xs\"\u003e\u003c/span\u003ec’est un peu la jungle'
export const TEST13M_ET_POUR_FINIR_LA_POINTURE = '... et pour finir la pointure !'
export const TEST13M_ETAPE = 'Étape'
export const TEST13M_ETAPE_SUIVANTE = 'Suivant'
export const TEST13M_JAMELIORE_MON_EXP_ACHAT = 'J\u0027améliore mon expérience d\u0027achat'
export const TEST13M_JE_CHERCHE_POUR = 'Je cherche pour :'
export const TEST13M_JE_SELECTIONNE_TAILLE = 'Je sélectionne la taille de'
export const TEST13M_LA_TAILLE_DE_BAS = '... la taille de bas'
export const TEST13M_MON_PROFIL_PERSO = 'Mon profil personnalisé'
export const TEST13M_NE_PERDEZ_PAS_DE_VUE_VOS_BONNES_AFFAIRES = 'Ne perdez pas de vue vos bonnes affaires, et rentrez immédiatement votre profil en moins \u003cstrong\u003eDE 30 SECONDES.\u003c/strong\u003e'
export const TEST13M_SI_ON_REPERE_DES_PETITS_PRIX = 'Si on repère toujours des petits prix, c’est en cherchant sa taille que l’on peut s’y perdre.'
export const TEST23M_AMELIO_EXP_ACHAT = 'Améliorez votre \u003cspan class=\"visible-xs\"\u003e\u003c/span\u003eexpérience d\u0027achat'
export const TEST23M_CEST_PARTI = 'C\u0027est parti !'
export const TEST23M_ET_POUR_FINIR = '... \u003cspan class=\"visible-xs\"\u003e\u003c/span\u003eet pour finir !'
export const TEST23M_ET_POUR_LES_PANTALONS = '... \u003cspan class=\"visible-xs\"\u003e\u003c/span\u003eet pour les pantalons ?'
export const TEST23M_MA_POINTURE = 'Ma pointure est :'
export const TEST23M_MA_TAILLE_DE_HAUT = 'Ma taille de haut est :'
export const TEST23M_MA_TAILLE_EST = 'Ma taille est :'
export const TEST23M_SELECTIONNEZ_VOS_INFOS_DE_PROFIL = 'Sélectionnez vos \u003cspan class=\"visible-xs\"\u003e\u003c/span\u003einformations de profil'
export const TEST33M_CHEZ_MODZ_CHAQUE_PRODUIT_EST_UNIQUE = 'Chez Modz, chaque produit est unique.'
export const TEST33M_SELECTIONNEZ_VOS_TAILLES = 'Sélectionnez vos tailles\u003cbr /\u003epour faire des trouvailles !'
export const TEST43M_POINTURE_DE_CHAUSSURES = 'Pointure de\u003cspan class=\"visible-xs\"\u003e\u003c/span\u003e chaussures :'
export const TEST43M_TAILLE_POUR_LE_BAS = 'Taille pour le bas :'
export const TEST43M_TAILLE_POUR_LE_HAUT = 'Taille pour le haut :'
export const TEST43M_VOUS_RECHERCHEZ_POUR = 'Vous recherchez pour :'
export const TEST73M_POINTURE = 'Pointure'
export const TEST73M_TAILLE_DE_BAS = 'Taille de bas'
export const TEST73M_TAILLE_DE_HAUT = 'Taille de haut'
export const TOP_DES_MARQUES = 'Top des marques'
export const TOTAL_A_PAYER = 'Total à payer'
export const TOTAL_ÉCONOMISE = 'Total économisé'
export const TOTAL_MAJ = 'TOTAL : '
export const TOTAL_REGLER = 'Total à régler'
export const TOTALARTICLESTTC = 'Total Articles TTC'
export const TOTALHT = 'Total HT'
export const TOTALTTC = 'Total TTC'
export const TOUS_GENRES = 'Tous les genres'
export const TOUS_LES_BAS = 'Tous les bas'
export const TOUS_LES_HAUTS = 'Tous les hauts'
export const TOUS_PAYS = 'Tous les pays'
export const TOUTES_LES_CHAUSSURES = 'Toutes les chaussures'
export const TOUTES_LES_COULEURS = 'Toutes les couleurs'
export const TOUTES_NOS_MARQUES = 'Toutes nos marques'
export const TRANSPORTEUR = 'Transporteur'
export const TRIER_PAR = 'Trier par'
export const TROP_DARTICLES = 'Trop d\u0027articles ? Faites le tri !'
export const TROP_TARD = 'Trop tard !'
export const TROUVEZ_DES_ARTICLES_A_VOTRE_TAILLE = 'Trouvez des articles à votre taille en un clic !'
export const TTC = 'TTC'
export const TYPE = 'Type'
export const UN_CADEAU_POUR_ELLE = 'Un cadeau pour elle'
export const UN_CADEAU_POUR_LUI = 'Un cadeau pour lui'
export const UN_EMAIL_ÉTÉ_ENVOYE = 'Un e-mail a été envoyé à l\u0027adresse suivante : '
export const UN_ZESTE_DE_PROMO_EN_PLUS_MAJ = 'UN ZESTE DE PROMO EN PLUS'
export const UNE_ALERTE_SUR_LES_NOUVEAUTES_DE = 'Une alerte sur les nouveautés de'
export const UNIVERS = 'Univers :'
export const UNIVERS0 = 'Univers'
export const UTILISATION_EMAIL_COMPTE = 'Votre adresse mail doit correspondre celle utilisée pour votre compte.'
export const UTILISER_AUTRE_CARTE = 'Utiliser une autre carte'
export const UTILISER_CODE_PROMO = 'Vous avez un code promo ? Cliquez ici !'
export const VALIDER = 'valider'
export const VALIDER_DEMANDE_RETOUR = 'Valider ma demande de retour'
export const VALIDER_ET_CONTINUER = 'Valider et continuer'
export const VALIDER_MON_PANIER = 'Valider mon panier'
export const VALIDER_MON_RETOUR = 'Valider mon retour'
export const VARIABLE_EN_FONCTION_DU_CONTENU_DU_PANIER = 'variable en fonction du contenu du panier'
export const VENDREDI = 'Vendredi'
export const VERIFIER_MAJ = 'VERIFIER'
export const VERIFIER_SPAM = 'Vous n\u0027avez rien reçu ? Pensez à vérifier vos spams !'
export const VETEMENTS_FEMME = 'Vêtements femme'
export const VETEMENTS_FEMME_PAS_CHER = 'Vêtements femme pas cher'
export const VETEMENTS_FILLE = 'Vêtements fille'
export const VETEMENTS_FILLE_PAS_CHER = 'Vêtements fille pas cher'
export const VETEMENTS_GARCON = 'Vêtements garçon'
export const VETEMENTS_GARCON_PAS_CHER = 'Vêtements garçon pas cher'
export const VETEMENTS_HOMME = 'Vêtements homme'
export const VETEMENTS_HOMME_PAS_CHER = 'Vêtements homme pas cher'
export const VETEMENTS_OCCASION_FEMME = 'Vêtements d\u0027occasion femme'
export const VETEMENTS_OCCASION_HOMME = 'Vêtements d\u0027occasion homme'
export const VEUILLEZ_CLIQUER_POUR_CONNECTER = 'Cliquer ici pour vous connecter'
export const VEUILLEZ_MODIFIER_VOS_TAILLES = 'Veuillez modifier vos tailles'
export const VEUILLEZ_SELECTIONNER_TAILLES = 'Veuillez sélectionner ou modifier vos tailles'
export const VIGNETTE_PRODUIT = 'Vignette Produit'
export const VILLE = 'Ville'
export const VINGT_EUROS = '20€'
export const VIREMENT_BANCAIRE = 'Virement bancaire'
export const VITE_JE_SHOPPE_MAJ = 'VITE, JE SHOPPE !'
export const VOIR_ARTICLE = 'VOIR L\u0027ARTICLE'
export const VOIR_BON_RETOUR = 'Voir le bon de retour'
export const VOIR_CADEAUX_MODE_MAJ = 'VOIR CADEAUX MODE'
export const VOIR_CONDITIONS_PARRAINAGE = 'Voir les conditions de parrainage'
export const VOIR_LA_MARQUE = 'Voir la marque'
export const VOIR_LA_MARQUE_MAJ = 'VOIR LA MARQUE'
export const VOIR_LA_SELECTION = 'Voir la sélection'
export const VOIR_LA_SUITE = 'Voir la suite'
export const VOIR_LES = 'Voir les'
export const VOIR_LES_HORAIRES = 'Voir les horaires'
export const VOIR_LOOKBOOK = 'Voir le lookbook'
export const VOIR_MA_SELECTION = 'Voir ma sélection'
export const VOIR_MA_SELECTION_PERSO = 'Voir ma sélection'
export const VOIR_MES_COMMANDES = 'Suivre mes commandes'
export const VOIR_MON_COMPTE = 'Voir mon compte'
export const VOIR_MON_PANIER = 'Voir mon panier'
export const VOIR_PLUS = 'Voir plus'
export const VOIR_SELECTION_VINS_MAJ = 'VOIR SÉLECTION VINS'
export const VOIR_TOUS_ARTICLES = 'Voir tous les articles'
export const VOIR_TOUT = 'Voir tout'
export const VOIR_TOUTE_MA_SELECTION = 'Voir toute ma sélection'
export const VOIR_TOUTES_LES_MARQUES = 'Voir toutes les marques'
export const VOIRVOS = 'VOIR VOS'
export const VOS = 'Vos'
export const VOS_CARTES_PAIEMENT = 'Vos cartes de paiement'
export const VOS_COMS_PARTICULIERS_SUR_CE_RETOUR = 'Vos commentaires particuliers sur ce retour :'
export const VOS_DONNES_PROTEGEES = 'Vos données protégées'
export const VOS_FILLEULS = 'Vos filleuls'
export const VOS_SPACE = 'Vos '
export const VOS_TAILLES = 'Vos tailles'
export const VOTRE_ADRESSE_EMAIL = 'Votre adresse email'
export const VOTRE_ADRESSE_MAIL = 'Votre adresse mail'
export const VOTRE_ADRESSE_NEST_PAS_REPERTORIEE = 'Votre adresse n\u0027est pas répertoriée ?'
export const VOTRE_ARTICLE_EST_RESERVE_PENDANT_1_HEURE = 'Votre article est réservé pendant \u003cb\u003e1 heure.\u003c/b\u003e'
export const VOTRE_CMD_SERA_EXPEDIEE = 'Votre commande sera expédiée dès réception de votre règlement.'
export const VOTRE_COLIS_EXPEDIE = 'Votre colis expédié par '
export const VOTRE_COLIS_RETOUR = 'Votre colis de retour'
export const VOTRE_COMMANDE = 'Votre commande'
export const VOTRE_CP_DE_NAISSANCE = 'Votre code postal de naissance :'
export const VOTRE_DRESSING_VA_ADORER_NOTRE_NOTRE_NEWS = 'Votre dressing va adorer notre newsletter !'
export const VOTRE_NOM_DE_NAISSANCE = 'Votre nom de naissance :'
export const VOTRE_PAIEMENT_A_ETE_ANNULE = 'Votre paiement a été annulé.'
export const VOTRE_PAIEMENT_A_ETE_REFUSE = 'Votre paiement a été refusé.'
export const VOTRE_PARRAIN = 'Votre parrain :'
export const VOTRE_PASS_A_ETE_RESET = 'Votre mot de passe a été réinitialisé.'
export const VOTRE_REF_CLIENT = 'Votre référence client :'
export const VOTRE_SELECTION_PERSO = 'Votre sélection personnalisée'
export const VOTRE_SHOPPING = 'Votre shopping uniquement sur des articles dans votre taille grâce au profil.'
export const VOTRETAILLE = 'Votre taille'
export const VOUS = 'Vous'
export const VOUS_ADOREZ = 'Vous adorez'
export const VOUS_AIMEREZ_SUREMENT = 'Vous aimerez sûrement'
export const VOUS_AVEZ = 'Vous avez'
export const VOUS_AVEZ_AJOUTER_PANIER = 'Cet article a bien été ajouté à votre panier'
export const VOUS_AVEZ_ECONOMISE = 'Vous avez économisé'
export const VOUS_AVEZ_QUITTE_PAGE_PAIEMENT = 'Vous avez quitté la page de paiement. Votre commande sera expédiée une fois que le paiement sera finalisé.'
export const VOUS_AVEZ_RECU_CARTE_CADEAU = 'Vous avez reçu une carte cadeau Modz et vous souhaitez l’utiliser.'
export const VOUS_BENEFICIEZ_DE = 'Vous bénéficiez de'
export const VOUS_CONNECTEZ_CODE_PROMO = 'Un code promo? Connectez-vous !'
export const VOUS_DEVEZ_CHOISIR_POINT_RELAY = 'Vous devez choisir un point relais pour la livraison avant d\u0027accéder au paiement.'
export const VOUS_NAVEZ_PAS_DE_MESSAGES = 'Vous n\u0027avez pas de message.'
export const VOUS_POUVEZ_BENEFICIER_DE = 'Vous pouvez bénéficier de'
export const VOUS_POUVEZ_REGLER_VOTRE_COMMANDE = 'Vous pouvez régler votre commande à l\u0027aide d\u0027un autre moyen de paiement ou bien l\u0027annuler directement ci-dessous.'
export const VOUS_POUVEZ_SUIVRE_COMMANDE = 'Vous pouvez suivre l\u0027évolution de votre commande à partir de l\u0027onglet Mon compte.'
export const VOUS_RECEVREZ_PAR_MAIL = 'Vous recevrez par e-mail tous les nouveaux produits correspondant à vos critères dès leur mise en ligne.'
export const VOUS_TROUVEREZ_LA_PROCEDURE_RETOUR = 'Vous trouverez ci-après la procédure de retour à bien respecter.'
export const VOUS_UTILISEZ_LAVOIR_POUR_UN_PROCHAIN_ACHAT = 'Vous utilisez l\u0027avoir pour un prochain achat ou vous demandez le remboursement : c\u0027est vous qui choisissez !'
export const X_PERSONNES_ONT_AJOUTE_AUX_FAVORIS = 'personnes ont ajouté ce produit à leur favoris.'
export const ZOOM_SUR_MARQUES = 'Zoom sur les marques'
